
export function statusInterceptor(
	$q,
	$injector
) {
	return {
		response(resp) {
			if(resp?.data?.Success !== undefined && resp?.data?.Success != null && !resp?.data?.Success) {
				handleErrorMessage(resp.data.Errors?.[0]);
				return $q.reject(resp);
			}
			return resp;
		},

		responseError(response) {
			// DO NOT REMOVE: will reimplement later when server supports it
			// if(response.status == 503) {
			// 	response.data.Success = true;

			// 	let isBackgroundRequest = false;
			// 	if(response.config.url.indexOf("api") < 0 || response.config.url.indexOf("api/authenticate/token") > -1) {
			// 		isBackgroundRequest = true;
			// 	}

			// 	const appState = $injector.get("appState");
			// 	appState.setUnavailable(response.data.Errors[0], isBackgroundRequest);

			// 	const api = $injector.get("api");
			// 	const timeout = $injector.get("$timeout");

			// 	return timeout(() => {
			// 		return api.http(response.config)
			// 			.then((response) => {
			// 				appState.clearUnavailable();
			// 				return response;
			// 			})
			// 			.catch(() => {
			// 				appState.clearUnavailable();
			// 			});
			// 	}, 30000);
			// }
			// else {
			let message;

			if(response.status == -1) {
				message = "Unable to connect to the internet. Please ensure you are connected.";
			}
			else if(response.status !== 404 && response.data && (response.data.Errors || []).length) {
				message = `Errors from server:<br/><br/>${response.data.Errors.join("<br/><br/>")}`;
			}

			if(response.status !== 400 || !response.success) {
				handleErrorMessage(message);
			}

			return $q.reject(response);
		}
		// }
	};

	function handleErrorMessage(message) {
		if(message) {
			$injector.get("toastr").error(message);
		}
	}
}
